<template>
  <m-dropdown
    v-model:value="showSortOptions"
    class="list-sorter"
    :title="$t('listSorter.title')"
    block
    :disabled="disabled"
  >
    <m-btn
      class="_btn"
      small
      hide-border
      icon="order"
      fab
      :disabled="disabled"
      :color="color"
      :light="!hasValue"
      @click.stop="handleSortClick"
    >
      <div
        v-if="hasUnsavedChanges"
        class="_dot"
      >
        <change-indicator />
      </div>
    </m-btn>
    <template #overlay>
      <m-card no-padding>
        <sorter-options
          :sort-options="sortOptions"
          @add-sort="handleSortOptionClick"
        />
      </m-card>
    </template>
  </m-dropdown>
</template>

<script setup>
import ChangeIndicator from '@/components/list/ChangeIndicator.vue';
import SorterOptions from '@/components/sorter/SorterOptions.vue';
import { VIEW_EVENT_BUS } from '@/lib/constants';
import { computed, inject, ref } from 'vue';

const props = defineProps({
  sortOptions: {
    type: Array,
    required: true,
  },
  hasValue: {
    type: Boolean,
    default: false,
  },
  hasUnsavedChanges: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const eventBus = inject(VIEW_EVENT_BUS);

const showSortOptions = ref(false);

const color = computed(() => {
  if (props.hasValue) {
    return 'primary';
  }
  return '';
});

const handleSortClick = () => {
  if (props.hasValue) {
    eventBus.$emit('toggle-view-toolbar', { toolbarAction: 'sorter' });
    return;
  }
  showSortOptions.value = true;
};

const handleSortOptionClick = (option) => {
  eventBus.$emit('add-sort', option);
  showSortOptions.value = false;
};
</script>

<style scoped lang="scss">
.list-sorter {
  ._btn {
    position: relative;

    ._dot {
      position: absolute;
      right: .3rem;
      top: .3rem;
    }
  }
}
</style>
